<button 
    mat-mini-fab
    [routerLink]="'kaufen'">
    <mat-icon>shopping_cart</mat-icon>
</button>
